
import React from "react";
import Header from "../shared/Header";
import Footer from "../shared/Footer";
import { i18nManager } from "../../i18n";
import Breadcrumb from "../shared/Breadcrumb";
import * as ReactRouterDom from "react-router-dom";
import { CacheManager, Debugger, Utils } from "../../utils";
import { SupportCommunityService, ISupportCommunity, IPlatform, SanitizedResponse, ApiResponseData } from "../../services";

function Communities() {
    const labels = i18nManager.Labels.contact;
    const { platform } = ReactRouterDom.useParams();
    const activePlatform = CacheManager.getPlatform(platform);
    const supportCommunityService = SupportCommunityService.getInstance();
    const [supportCommunities, setSupportCommunities] = React.useState<ApiResponseData<ISupportCommunity>>({});

    React.useEffect(() => {
        if (!activePlatform) return;
        supportCommunityService.querySupportCommunities({ sort: "id,DESC", "platform.external_id": activePlatform?.external_id, size: 100 }).then(({ sanitized }: SanitizedResponse<any>) => {
            Debugger.log("Communities:useEffect:querySupportCommunities", sanitized);
            setSupportCommunities(sanitized);
        }).catch((error: SanitizedResponse<any>) => {
            Utils.reportError(error);
        });
    }, []);

    return (<div className="support">
        <Header title={labels.title} />
        <Breadcrumb breadCrumbs={[{ label: labels.title, location: `/${platform}/contact-us` }, { label: labels.communities, location: window.location.href }]} />
        <div className="communities">
            {supportCommunities.content?.map((community) => (<div key={community.title}>
                <img alt={community.title} src={community.icon_location} />
                <div>
                    <span>{community.title}</span>
                    <a rel="noreferrer" target="_blank" href={community.url_location}>{community.url_location}</a>
                </div>
            </div>))}
        </div>
        <Footer />
    </div>);

}

export default Communities;
